import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { RadioGroup, Radio, Divider } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogContent from '@material-ui/core/DialogContent';
import Checkbox from '@material-ui/core/Checkbox';
import React, { useState } from 'react';
import {
  handleCheckboxChange,
  handleRadioChange,
  handleSelectAll,
  initialRadio,
  mapArrays,
  SubmitModal,
} from './ImportExportHelpers';
import { connect } from 'react-redux';
import {
  importExcelAll,
  importExcelManually,
  importExcelNew,
  importExcelOptionTypes,
} from 'Actions/projectActions';
import { useEffect } from 'react';

const ImportExcel = ({
  file,
  onClose,
  projectId,
  importExcelAll,
  importExcelNew,
  importExcelOptionTypes,
  importExcelManually,
  options,
}) => {
  const [radioValue, setRadioValue] = useState('');
  const [checkboxValue, setCheckboxValue] = useState([]);
  const [submitModalArr, setSubmitModalArr] = useState(false);
  const [submitModalOpen, setSubmitModalOpen] = useState(false);

  const handleClose = () => {
    onClose();
    setRadioValue('');
    setCheckboxValue([]);
    setSubmitModalArr(false);
    setSubmitModalOpen(false);
  };

  const handleSubmit = () => {
    if (radioValue === '1') importExcelAll(projectId, file);
    if (radioValue === '2') importExcelNew(projectId, file);
    if (radioValue === '3') return importExcelOptionTypes(projectId, file);
    handleClose();
  };

  const handleSecondStepSubmit = () => {
    const { secondStepArr, thirdStepArr } = mapArrays(checkboxValue);
    if (thirdStepArr.length) {
      setSubmitModalArr(thirdStepArr);
      setSubmitModalOpen(true);
      return;
    }
    if (secondStepArr.length) {
      importExcelManually(projectId, file, secondStepArr);
      handleClose();
    }
  };

  const handleThirdStepSubmit = () => {
    const { secondStepArr, thirdStepArr } = mapArrays(checkboxValue);
    if (secondStepArr.length) {
      importExcelManually(projectId, file, secondStepArr);
      handleClose();
    }
  };

  useEffect(() => {
    if (options.length) {
      let tempArr = [];
      options.forEach((item, index) =>
        tempArr.push({
          id: index,
          name: item.name,
          haveResponse: item.response,
          isChecked: false,
        })
      );
      setCheckboxValue(tempArr);
    }
  }, [options]);

  return (
    <Dialog
      classes={{
        paper: 'e-zindex--max bc-gray share-dialog',
      }}
      maxWidth="sm"
      open={file ? true : false}
      onClose={handleClose}
    >
      <h4 className="t-primary-20 t-weight--b t-align-c u-mrg-top-50 u-mrg-bot-50 u-pad-r-25 u-pad-l-25">
        Create/Update searches for selected types
      </h4>

      <DialogContent>
        {checkboxValue.length ? (
          <div>
            <div>
              {checkboxValue.map((item, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      value={item.name}
                      checked={item.isChecked}
                      onChange={e =>
                        handleCheckboxChange(
                          index,
                          e.target.checked,
                          setCheckboxValue
                        )
                      }
                    />
                  }
                  label={item.name}
                />
              ))}
            </div>
            <Divider light />
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    value="Select all"
                    onChange={e =>
                      handleSelectAll(e.target.checked, setCheckboxValue)
                    }
                  />
                }
                label="Select all"
              />
            </div>
          </div>
        ) : (
          <RadioGroup
            name="luminaire-radio"
            value={radioValue}
            onChange={e => handleRadioChange(e, setRadioValue)}
          >
            {initialRadio.map((item, index) => (
              <FormControlLabel
                key={index}
                control={<Radio />}
                value={item.value}
                label={item.label}
              />
            ))}
          </RadioGroup>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          classes={{
            root: 't-primary-16 c-blue-2-light t-weight-b',
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          classes={{
            root: 't-primary-16 c-s-blue',
          }}
          onClick={checkboxValue.length ? handleSecondStepSubmit : handleSubmit}
          variant="contained"
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
      <SubmitModal
        handleClose={() => setSubmitModalOpen(false)}
        modalArr={submitModalArr}
        modalOpen={submitModalOpen}
        confirm={handleThirdStepSubmit}
      />
    </Dialog>
  );
};

const mapStateToProps = store => {
  return {
    options: store.projects.options,
  };
};

const mapDispatchToProps = dispatch => ({
  importExcelAll: (projectId, excelFile) => {
    dispatch(importExcelAll(projectId, excelFile));
  },
  importExcelNew: (projectId, excelFile) => {
    dispatch(importExcelNew(projectId, excelFile));
  },
  importExcelOptionTypes: (projectId, excelFile) => {
    dispatch(importExcelOptionTypes(projectId, excelFile));
  },
  importExcelManually: (projectId, excelFile, referenceNames) => {
    dispatch(importExcelManually(projectId, excelFile, referenceNames));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportExcel);
